module.exports = __webpack_public_path__ + "img/no-date-red.d18a2e65.png";